import apiClient from "./axiosInstance"

export interface ExternalUserPipelineStats {
  totalExternalUsers: number
  scrapedExternalUsers: number
}

export interface ExternalUserPostStats {
  totalPosts: number
  totalExternalUsers: number
  savedPosts: number
  unsavedPosts: number
  withImageDescriptionV4: number
  withoutImageDescriptionV4: number
  withVideoAnalysis: number
  withoutVideoAnalysis: number
  lastUpdated?: string | null
}

export const TAgetExternalUserPipelineStats = async (): Promise<ExternalUserPipelineStats> => {
  const response = await apiClient.get(
    "/admin/external-user-pipeline/external-user-pipeline-stats",
    {
      timeout: 30000,
    },
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("External user pipeline istatistikleri alınamadı")
  }
}

export const TAgetExternalUserPostStats = async (): Promise<ExternalUserPostStats> => {
  const response = await apiClient.get("/admin/external-user-pipeline/external-user-post-stats", {
    timeout: 30000,
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("External user post istatistikleri alınamadı")
  }
}
